import clsx from 'clsx';
import React from 'react';

import { I18nLink } from '@/lib/components/I18nLink';

import { ArticleItemSidebarProps } from './types';
import styles from './ArticleItemSidebar.module.scss';

export function ArticleItemSidebar({ article, type, isActive = false, onClick, className }: ArticleItemSidebarProps) {
  const itemClasses = clsx(styles.article, className, { [styles.active]: isActive }, { 'text-bold': isActive });

  return (
    <I18nLink href={`/helpdesk/${type}/${article.slug}`} className={itemClasses} onClick={onClick}>
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.sidebarIcon}>
        <path d="M12.7375 3.98125V14.125H2V1H9.75625L12.7375 3.98125Z" />
        <path d="M4.42139 7.5625H10.3164" />
        <path d="M4.42139 10.5875H10.3164" />
        <path d="M12.6436 3.95141V4.55641H9.125V0.945312H9.7145L12.6436 3.95141Z" />
      </svg>
      <span className={styles.articleText}>
        <span className={styles.articleTitle}>{article.title}</span>
      </span>
    </I18nLink>
  );
}
